export enum GenderEnum {
    MALE = "Male",
    FEMALE = "Female",
    OTHERS = "Others"
}